var audio_rtlignore_default = {
  "fontElementMap": "hfqh-",
  "container": "g89QG",
  "customPlayer": "t2cZD",
  "slim": "QNJn0",
  "playPauseButton": "uRrId",
  "coverImage": "_1xfv4",
  "trackDetailsContainer": "n4BPd",
  "controlsContainer": "_74UbB",
  "controlsGroup": "AZyuy",
  "sliderContainer": "LhXcL",
  "audioDuration": "Wt-tu",
  "isLoading": "PLRWk",
  "audioDetails": "_8tgSK",
  "authorName": "hDkDx",
  "title": "YJLaM",
  "dropdownMenuWrapper": "m7uBB",
  "dropdownSelectedButton": "azbE1",
  "dropdownContent": "DQKPi",
  "dropdownContentWithIcon": "_8uVKj",
  "audioLoader": "KUx4g"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
